(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
$(document).on("click","#faqContent h4", function(){
  $(this).toggleClass("active");
 
 if($(this).hasClass("active")){
    $(this).siblings("p").hide();
    $(this).next("p").show();
  }
  else{
     $(this).next("p").hide();
  }
});
  $(document).on("click","#faqContent h5", function(){
  $(this).toggleClass("active");
 
 if($(this).hasClass("active")){
    $(this).siblings("p").hide();
    $(this).next("p").show();
  }
  else{
     $(this).next("p").hide();
  }
});
  $(document).on("click","#faqContent h6", function(){
  $(this).toggleClass("active");
 
 if($(this).hasClass("active")){
    $(this).siblings("p").hide();
    $(this).next("p").show();
  }
  else{
     $(this).next("p").hide();
  }
});


  } catch(e) { console.error(e); }
})();
})();
